module.exports = __webpack_public_path__ + "static/littleWomen6s-1fc6290fffbb8edd1c613cf9f93704f7.jpg";